// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"3f171a5f","488":"aa56ee85"}[chunkId] + ".chunk.js";
};